import { createGlobalStyle } from 'styled-components';

import '~src/fonts/open-sans-v15-latin_latin-ext-300.woff';
import '~src/fonts/open-sans-v15-latin_latin-ext-300.woff2';
import '~src/fonts/open-sans-v15-latin_latin-ext-300italic.woff';
import '~src/fonts/open-sans-v15-latin_latin-ext-300italic.woff2';
import '~src/fonts/open-sans-v15-latin_latin-ext-600.woff';
import '~src/fonts/open-sans-v15-latin_latin-ext-600.woff2';
import '~src/fonts/open-sans-v15-latin_latin-ext-600italic.woff';
import '~src/fonts/open-sans-v15-latin_latin-ext-600italic.woff2';
import '~src/fonts/open-sans-v15-latin_latin-ext-italic.woff';
import '~src/fonts/open-sans-v15-latin_latin-ext-italic.woff2';
import '~src/fonts/open-sans-v15-latin_latin-ext-regular.woff';
import '~src/fonts/open-sans-v15-latin_latin-ext-regular.woff2';

import { antdDatePicker } from './antdOverrides/datePicker';
import { antdDrawer } from './antdOverrides/drawer';
import { antdModal } from './antdOverrides/modal';
import { antdPopover } from './antdOverrides/popover';
import { antdRangePicker } from './antdOverrides/rangePicker';
import { antdSelect } from './antdOverrides/select';
import { antdSlider } from './antdOverrides/slider';
import { antdTable } from './antdOverrides/table';
import { resetElementsCss } from './reset';
import { typography } from './typography/typography';

// * { background-color: rgba(255,0,0,.2); }
// * * { background-color: rgba(0,255,0,.2); }
// * * * { background-color: rgba(0,0,255,.2); }
// * * * * { background-color: rgba(255,0,255,.2); }
// * * * * * { background-color: rgba(0,255,255,.2); }
// * * * * * * { background-color: rgba(255,255,0,.2); }
// * * * * * * * { background-color: rgba(255,0,0,.2); }
// * * * * * * * * { background-color: rgba(0,255,0,.2); }
// * * * * * * * * * { background-color: rgba(0,0,255,.2); }

// tslint:disable-next-line:no-unused-expression
export const GlobalStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  html,
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: 15px;
  }

  body {
    font-family: 'Open Sans', sans-serif;
    line-height: normal;
    color: ${({ theme }) => theme.baseBlue.a10};
    background: ${({ theme }) => theme.background};
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  .lls-root {
    height: 100%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.baseBlue.a10};
  }

  h1,
  h2,
  p {
    margin: 0;
  }

  a {
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.baseBlue.a10};
      text-decoration: inherit;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  input {
    border: 0;
  }

  input[type='radio'],
  input[type='checkbox'] {
    margin-right: 0.5rem;
  }

  ${typography}
  ${antdModal}
  ${antdSelect}
  ${antdDatePicker}
  ${antdRangePicker}
  ${antdPopover}
  ${antdSlider}
  ${antdDrawer}
  ${antdTable}

  /* Reset elements classes */
  ${resetElementsCss}

  /* only for production needed */
  .ant-popover {
    z-index: 9999;
  }
`;
